import { DatabaseLayoutType } from '@databases/types/database/view';
import * as Parsimmon from 'parsimmon';

import { TokenType } from '../types';

export const LayoutLang = Parsimmon.createLanguage({
  /**
   * <Statement> -> table|gallery|<Board>
   *
   * "table" and "gallery" are terminals
   * @param r - language
   */
  Statement: function (r) {
    return Parsimmon.alt(
      Parsimmon.string('table').map(() => DatabaseLayoutType.TABLE),
      Parsimmon.string('gallery').map(() => DatabaseLayoutType.GALLERY),
      r.Board
    ).map((result) => {
      if (result === DatabaseLayoutType.TABLE || result === DatabaseLayoutType.GALLERY) {
        return {
          tokenType: TokenType.LAYOUT,
          type: result,
        };
      } else {
        return {
          tokenType: TokenType.LAYOUT,
          ...result,
        };
      }
    });
  },

  /**
   * <Board> -> 'board[<FieldName>'
   *
   * "board[" is a terminal
   * After <FieldName>, everything is ignored
   * @param r - language
   */
  Board: function (r) {
    return Parsimmon.seq(Parsimmon.string('board['), r.FieldName)
      .skip(Parsimmon.all)
      .map(([_, fieldName]) => ({
        type: DatabaseLayoutType.BOARD,
        groupField: fieldName,
      }));
  },

  /**
   * <FieldName> -> Examples: 'FieldName', 'My Field 1'
   *
   * This is a terminal.
   * A <FieldName> is anything wrapped in single quotes
   */
  FieldName: function () {
    const escapedChar = Parsimmon.string('\\')
      .then(Parsimmon.any)
      .map((c) => c);
    const normalChar = Parsimmon.noneOf("'");
    const content = Parsimmon.alt(escapedChar, normalChar);

    return Parsimmon.string("'")
      .then(content.many().map((chars) => chars.join('')))
      .skip(Parsimmon.string("'"));
  },

  _: function () {
    return Parsimmon.whitespace;
  },
});
